// @flow
import { createSelector } from 'reselect';
import shallowequal from 'shallowequal';

import { selectPricingInfos } from '@gandi/billing';
import { selectDiscounts, type Discount } from '@gandi/cart';
import type { ReduxSelector } from '@gandi/flow-types';
import { instances, type InstancePrice } from '@gandi/redux-resource-price';

import type { Dispatch, FullState, GetState } from '../../types';

const SHS50couponPrefixes = ['PAAS', 'SHS', 'GWH'];

// --------------------------------------------------------------------- Actions

export const fetchInstancePrices =
  (options: { ... } = {}): ((dispatch: Dispatch, getState: GetState) => any) =>
  (dispatch: Dispatch, getState: GetState) => {
    const pricingInfos = selectPricingInfos(getState());
    return dispatch(
      // $FlowFixMe[cannot-spread-inexact]
      instances.fetchAll({
        ...pricingInfos,
        ...options,
      }),
    );
  };

export const selectSharedFeatures: ReduxSelector<
  FullState,
  void,
  InstancePrice['features'],
  // $FlowFixMe[incompatible-call]
> = createSelector(instances.selectPricesArray, instancePrices =>
  instancePrices[0]
    ? instancePrices[0].features.filter(feature =>
        instancePrices.every(
          price =>
            price.features.find(item => shallowequal(item, feature)) !==
            undefined,
        ),
      )
    : [],
);

export const selectSHSCartDiscount: (state: FullState) => Discount | void =
  createSelector([selectDiscounts], discounts =>
    discounts.find(discount =>
      SHS50couponPrefixes.find(prefix =>
        discount.code ? discount.code.startsWith(prefix) : false,
      ),
    ),
  );
